import Button from 'components/button';
import Checkbox from 'components/checkbox';
import { Select } from 'components/select';
import { FavouritesType, UsersType } from 'lib/dictionary';
import { EFavoritesType, ISelectItem } from 'lib/types';
import { useState } from 'react';
import styles from './styles.module.scss';
import useChangeTypeFavoriteList from 'api/hooks/use-favorite-list-change-type';
import useUserList, { APIUser } from 'api/hooks/use-users-list';
import { getName } from 'lib/utils';
import { APIUserType } from 'api/types';

interface IChangeTypeFavoriteListForm {
  type: EFavoritesType;
  onClose: () => void;
  refetchList: () => void;
  id: number;
  title: string;
}

const ChangeTypeFavoriteListForm = ({
  type,
  onClose,
  refetchList,
  id,
  title,
}: IChangeTypeFavoriteListForm) => {
  const [isCheck, setIsCheck] = useState(true);
  const { users, isLoading } = useUserList();
  const [clientIds, setClientIds] = useState<number[]>([]);

  const payload = { type, userIds: clientIds, copyToMyself: isCheck };
  const { isMutating, error, trigger } = useChangeTypeFavoriteList(id, payload);

  const handleChangeType = async () => {
    if (id && clientIds.length) {
      await trigger();
      onClose();
      refetchList();
    }
  };

  const handleChange = (value: number[]) => {
    setClientIds(value);
  };

  const isShared = type === EFavoritesType.Shared;
  const isCustomer = type === EFavoritesType.Customer;

  const menuArrayOptions: ISelectItem[] = (function () {
    let userListFileterd: APIUser[] = [];

    if (isShared) {
      userListFileterd = users?.filter((user) => user.type !== APIUserType.CLIENT);
    }

    if (isCustomer) {
      userListFileterd = users?.filter((user) => user.type === APIUserType.CLIENT);
    }

    return userListFileterd.map((user) => ({
      key: user.id,
      label: getName(user.fullname),
      note: user.phone + ' ' + UsersType.label(user.type),
    }));
  })();

  return (
    <div className={styles.container}>
      <div className={styles.title}>{`${FavouritesType.label(type)} список ${title}`}</div>
      <div className={styles.select}>
        <Select
          size='lg'
          label={isShared ? 'Укажите пользователей' : 'Укажите пользователя'}
          search
          selected={isShared ? clientIds : clientIds[0]}
          multiple={isShared as any} // могут быть 2 состояни true или false
          onSelect={(value: any) => {
            Array.isArray(value)
              ? handleChange(value as number[])
              : handleChange([value as number]);
          }}
          menuArray={menuArrayOptions}
        />
      </div>
      <div className={styles.checkBox}>
        <Checkbox
          label='Оставить копию'
          onChange={(value) => setIsCheck(value)}
          checked={isCheck}
        />
      </div>
      <div className={styles.flexButton}>
        <Button variant='gray' onClick={onClose} label='Отменить' />
        <Button
          loading={isMutating}
          onClick={() => {
            handleChangeType();
          }}
          label='Создать'
        />
      </div>
    </div>
  );
};

export default ChangeTypeFavoriteListForm;
